module.exports = __webpack_public_path__ + "static/media/Hour_13-18.98bbe03d.png";